<template>
  <div class="ValidateRecords">
    <v-container fluid grid-list-lg>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md12>
          <v-layout wrap>
            <v-flex xs12 md7>
              <v-card class="mb-2">
                <v-card-title class="title">
                  Validar Audios
                  <v-spacer/>

                  <v-text-field
                    v-if="!loading && dataVals.length !== 0"
                    v-model="search"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>

                <v-card-text
                  v-if="loading"
                  class="text-xs-center"
                >
                  <v-progress-circular
                    :size="progressSize"
                    :width="progressWidth"
                    :value="completed"
                    color="info"
                  >
                    {{ progressAdvance }}
                    {{ progressTotal }}
                  </v-progress-circular>
                </v-card-text>

                <v-card-text v-else>
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="dataVals"
                    :search="search"
                    no-results-text="No se encontro el término buscado"
                    no-data-text="No hay datos disponibles"
                    multi-sort
                    disable-initial-sort
                    class="elevation-1"
                    loading="Cargando... Por favor espere."
                    :key="tableKey"
                  >
                    <template v-slot:items="props">
                      <td v-if="props.item.encuesta === IDEncuesta">
                        <strong> {{ props.item.encuesta }} </strong>
                      </td>
                      <td v-else>
                        {{ props.item.encuesta }}
                      </td>
                      <td class="justify-space-around">
                        <v-layout align-center justify-space-around>
                          <v-icon
                            color="info"
                            @click="loadPoll(props.item.encuesta)"
                          >
                            queue_music
                          </v-icon>
                        </v-layout>
                      </td>
                      <td>
                        <v-layout align-center justify-space-around>
                          <v-icon
                            color="success"
                            @click="editPoll(props.item, '0')"
                          >
                            check_circle
                          </v-icon>
                          <v-icon
                            color="error"
                            @click="editPoll(props.item, '2')"
                          >
                            cancel
                          </v-icon>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-dialog v-model="dialog" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Validar Audio</span>
                    </v-card-title>

                    <v-card-text>
                      Esta acción no se puede deshacer
                      <v-checkbox
                        v-model="checkbox"
                        label="Confirmo que deseo validar el audio"
                      ></v-checkbox>
                    </v-card-text>

                    <v-alert :value="alert" type="error">
                      No se ha podido realizar la validación
                    </v-alert>

                    <v-card-actions>
                      <v-spacer/>
                      <v-btn color="info" @click="close">Cancelar</v-btn>
                      <v-btn
                        :disabled="!this.checkbox"
                        color="warning"
                        @click="save"
                      >Enviar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
            </v-flex>

            <v-flex xs12 md5>
              <v-card class="mb-2" v-if="IDEncuesta !== null">
                <v-card-title class="title">
                  Audios Relacionados a la Encuesta: <br>
                  {{ IDEncuesta }}
                </v-card-title>

                <v-card-text
                  v-if="loadingRecords"
                  class="text-xs-center"
                >
                  <v-progress-circular
                    :size="progressSize"
                    :width="progressWidth"
                    indeterminate
                    color="info"
                  ></v-progress-circular>
                </v-card-text>

                <v-card-text v-else>
                  <v-data-table
                    dense
                    :headers="headersRecords"
                    :items="dataValsRecords"
                    no-results-text="No se encontro el término buscado"
                    no-data-text="No hay datos disponibles"
                    multi-sort
                    disable-initial-sort
                    class="elevation-1"
                    loading="Cargando... Por favor espere."
                    :key="tableRecordsKey"
                    item-key="id"
                  >
                    <template v-slot:items="props">
                      <tr @click="props.expanded = !props.expanded">
                        <td>
                          <v-checkbox
                            primary
                            hide-details
                          ></v-checkbox>
                        </td>
                        <td> {{ props.item.id }} </td>
                        <td class="justify-space-around">
                          <v-layout align-center justify-space-around>
                            <v-icon color="info">audiotrack</v-icon>
                          </v-layout>
                        </td>
                      </tr>
                    </template>

                    <template v-slot:expand="props">
                      <v-card flat>
                        <audio controls>
                          <source :src="props.item.url">
                          Tu navegador no soporta el audio.
                        </audio>
                      </v-card>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  name: `ValidateRecords`,

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.getPolls()
  },

  data: function () {
    return {
      backConf: {
        path: '/core/audios_cal',
        page: 1
      },

      operativo: null,

      search: '',
      dialog: false,
      loading: false,
      loadingRecords: false,
      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      alert: false,

      headers: [
        {
          text: 'Identificador Encuesta',
          value: 'encuesta',
          align: 'left'
        },
        { text: 'Audios', value: '', align: 'center', sortable: false },
        { text: 'Acciones', value: '', align: 'center', sortable: false }
      ],
      dataVals: [],
      tableKey: 0,

      headersRecords: [
        { text: '', value: '', align: 'center', sortable: false },
        {
          text: 'Identificador Audio',
          value: 'encuesta',
          align: 'left'
        },
        { text: 'Escuchar', value: 'url', align: 'center', sortable: false }
      ],
      dataValsRecords: null,
      tableRecordsKey: 0,

      editedIndex: -1,
      editedPoll: {},
      IDEncuesta: null,
      checkbox: false,
      incidenceType: null
    }
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    },

    dialog (val) {
      val || this.close()
    },

    'dataVals': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  methods: {
    /** Carga la información de las encuestas
     */
    getPolls () {
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          encuesta: 'all',
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.dataVals.length

          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getPolls()
          } else {
            t.backConf.page = 1
            t.loading = false
          }
        })
        .catch(err => console.error(err))

      t.tableKey += 1
    },

    /** Carga los audios relacionadops a la encuesta
     * @param  {string} IDEncuesta El identificador de la encuesta seleccionada
     */
    loadPoll (IDEncuesta) {
      if (!this.loadingRecords) {
        this.dataValsRecords = []
      }

      this.loadingRecords = true
      this.IDEncuesta = IDEncuesta

      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          encuesta: IDEncuesta,
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRecords = t.dataValsRecords.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.loadPoll()
          } else {
            t.backConf.page = 1
            t.loadingRecords = false
          }
        })
        .catch(err => console.error(err))

      t.tableRecordsKey += 1
    },

    /** Selecciona al encuesta a validar
     * @param  {object} poll encuesta a validar
     * @param  {char} inc  tipo de incidencia
     */
    editPoll (poll, inc) {
      this.editedIndex = this.dataVals.indexOf(poll)
      this.incidenceType = inc
      this.editedPoll = Object.assign({}, poll)
      this.dialog = true
    },

    /** Limpia el formulario de validación y limpia los elementos asociados
     */
    close () {
      this.dialog = false
      this.incidenceType = null
      this.checkbox = false
      this.alert = false

      setTimeout(() => {
        this.editedPoll = {}
        this.editedIndex = -1
      }, 300)
    },

    /** envia la validación,
     * actualiza la tabla local
     */
    save () {
      let request = {
        method: 'patch',
        data: {
          id: this.editedPoll.encuesta,
          calificacion: this.incidenceType
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals.splice(t.editedIndex, 1)
          t.alert = false
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          console.error(err)
        })
    }
  }
}
</script>

<style scoped>
  audio {
    width: 100%;
  }
</style>
